module.exports = __webpack_public_path__ + "img/uah.svg";